module.exports = __webpack_public_path__ + "img/flag_pt.450f4511.png";